var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "./TitlesElement.css", "../../themes"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("./TitlesElement.css"), require("../../themes"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.TitlesElement, global.themes);
    global.TitlesElement = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _TitlesElement, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.TitlesElement = void 0;
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _themes = _interopRequireDefault(_themes);

  var TitlesElement = function TitlesElement(_ref) {
    var theme = _ref.theme,
        display = _ref.display,
        format = _ref.format,
        isActive = _ref.isActive,
        isPlaceholder = _ref.isPlaceholder,
        slideKind = _ref.slideKind,
        subtitle = _ref.subtitle,
        title = _ref.title;

    switch (format) {
      case 'twolines':
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_TitlesElement.StyledTitle, {
          theme: _themes.default[theme],
          isActive: isActive,
          isPlaceholder: isPlaceholder,
          _display: display,
          slideKind: slideKind
        }, title), subtitle && /*#__PURE__*/_react.default.createElement(_TitlesElement.StyledSubTitle, {
          theme: _themes.default[theme],
          isActive: isActive,
          isPlaceholder: isPlaceholder,
          _display: display,
          slideKind: slideKind
        }, subtitle));

      case 'oneline':
      default:
        return /*#__PURE__*/_react.default.createElement(_TitlesElement.StyledTitle, {
          theme: _themes.default[theme],
          isActive: isActive,
          isPlaceholder: isPlaceholder,
          _display: display,
          slideKind: slideKind
        }, title, title && subtitle ? ' - ' : '', subtitle);
    }
  };

  _exports.TitlesElement = TitlesElement;
  TitlesElement.propTypes = {
    display: _propTypes.default.string,
    format: _propTypes.default.oneOf(['oneline', 'twolines']),
    isActive: _propTypes.default.bool,
    isPlaceholder: _propTypes.default.bool,
    slideKind: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    theme: _propTypes.default.string
  };
  TitlesElement.defaultProps = {
    display: '',
    format: 'oneline',
    isActive: false,
    isPlaceholder: false,
    slideKind: '',
    theme: 'next'
  };
  var _default = TitlesElement;
  _exports.default = _default;
});